<template>
    <TextButton title="Tiptel" link="/tiptel" id="tiptel-subnavigationTitle" />
</template>

<script lang="ts" setup>
    import TextButton from '@/components/Buttons/TextButton.vue'
</script>
